import React, { PropsWithChildren } from 'react'
import { createContext } from 'lib/createContext'
import { useAddRateMutation } from 'queries/wage/useAddRateMutation'
import { parseErrorMessage } from 'api'

type AddRateFlowContextState = {
  state: {
    mutationState: {
      isPending: boolean
      errorMessage: string | undefined
    }
  }
  actions: {
    submit: ReturnType<typeof useAddRateMutation>['mutate']
  }
}

const [Context, useAddRateFlowContextValue] =
  createContext<AddRateFlowContextState>({
    name: 'AddRateFlowContext',
  })

export const AddRateFlowProvider = ({
  children,
  ruleId,
}: PropsWithChildren<{ ruleId: number }>) => {
  const { mutate, isPending, error } = useAddRateMutation(ruleId)

  const value: AddRateFlowContextState = {
    state: {
      mutationState: {
        isPending,
        errorMessage: parseErrorMessage(error),
      },
    },
    actions: { submit: mutate },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useAddRateFlowContextValue }
